import { ReactNode } from 'react'
import { Controller, useFormContext } from 'react-hook-form'
import { RadioGroup, FormControlLabel, Radio, SxProps } from '@mui/material'

export interface RadioOption {
  value: string | number
  label: ReactNode
  disabled?: boolean
}

interface RadioControllerProps {
  name: string
  options: RadioOption[]
  row?: boolean
  sx?: SxProps
  defaultValue?: string | number
}

const RadioController = ({ name, options, row = false, sx, defaultValue }: RadioControllerProps) => {
  const { control } = useFormContext()

  return (
    <Controller
      name={name}
      control={control}
      defaultValue={defaultValue}
      render={({ field }) => (
        <RadioGroup {...field} row={row} sx={sx}>
          {options.map(option => (
            <FormControlLabel
              key={option.value}
              value={option.value}
              control={<Radio color="primary" />}
              label={option.label}
              disabled={option.disabled}
            />
          ))}
        </RadioGroup>
      )}
    />
  )
}

export default RadioController
